// src/plugins/builder/templates/index.ts
// Static catalog of all 12 builder templates. Adding a new template = drop a
// folder + add one import + one entry in TEMPLATES below.
import badReviewEmail from './bad-review-email/generator';
import autoReplyPositive from './auto-reply-positive/generator';
import exportGoogleSheets from './export-google-sheets/generator';
import disputeWonSlack from './dispute-won-slack/generator';
import weeklyTrendsSummary from './weekly-trends-summary/generator';
import competitorMention from './competitor-mention-flag/generator';
import sentimentAutoTag from './sentiment-auto-tag/generator';
import ratingDropNotify from './rating-drop-notify/generator';
import monthlyPdfReport from './monthly-pdf-report/generator';
import thankYouPositive from './thank-you-positive/generator';
import socialCrossPost from './social-cross-post/generator';
import newReviewWorkflow from './new-review-workflow/generator';
/** Twelve. Order matters — this is the order the wizard's grid renders them. */
export const TEMPLATES = [
    badReviewEmail,
    autoReplyPositive,
    exportGoogleSheets,
    disputeWonSlack,
    weeklyTrendsSummary,
    competitorMention,
    sentimentAutoTag,
    ratingDropNotify,
    monthlyPdfReport,
    thankYouPositive,
    socialCrossPost,
    newReviewWorkflow,
];
export const TEMPLATE_COUNT = TEMPLATES.length;
